import React, { useState } from "react";
import { Flex, Box, Text } from "ui-components";
import { Plus, Minus } from "components/Icons";
import FormattedMessage from "components/FormattedMessage";
import AnalyticsFactory from "analytics/AnalyticsFactory";
import { useSelector } from "react-redux";
import {
  makeSelectLoggedInUserDetails,
  makeSelectOrderRef
} from "ducks/selectors";
import { formatPathUrl } from "utils/helpers";
import { getGTMtagdata } from "analytics/utils/helpers";
import { FAQ_TYPE } from "utils/constants";
import Video from "./video";
const FAQItem = ({
  question,
  answer,
  type = "text",
  id,
  open = false,
  messageData = {},
  themeColors,
  faqProps,
  locale = {},
  ...metaInfo
}) => {
  const [seeMore, setSeeMore] = useState(open);
  
  const toggleSeeMore = () => {
    setSeeMore(!seeMore);
    AnalyticsFactory.pushEvent("faq_item_clicked", {}, "", {});
  };
  const { icon: iconColor } = themeColors || {};
  const loggedInUserDetails = useSelector(makeSelectLoggedInUserDetails());
  const orderRef = useSelector(makeSelectOrderRef());
  const containerName = formatPathUrl(window.location.pathname);
  const data_testid = containerName
    ? `${containerName}-faq-toggle-button`
    : "faq-toggle";
  

  return question && answer ? (
    <Flex data-testid="faq-item" id={id} className="faq-item">
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        className={seeMore ? "expanded" : ""}
        padding="12px 8px 12px 14px"
        onClick={toggleSeeMore}
        sx={{ cursor: "pointer" }}
        data-testid={data_testid}
        data-gtmdata={getGTMtagdata(
          data_testid,
          "faq_toggle",
          loggedInUserDetails,
          question,
          orderRef,
          locale
        )}
      >
        <Flex
          flexDirection="column"
          justifyItems="center"
          justifyContent="center"
        >
          <Text
            fontSize="16px"
            fontWeight={seeMore ? 700 : 400}
            lineHeight="19px"
            color={
              seeMore
                ? faqProps?.question?.highlightedColor ||
                  themeColors?.cta?.color
                : "inherit"
            }
            data-gtmdata={getGTMtagdata(
              data_testid,
              "faq_toggle",
              loggedInUserDetails,
              question,
              orderRef,
              locale
            )}
          >
            <FormattedMessage
              id={question}
              values={messageData}
              data-gtmdata={getGTMtagdata(
                data_testid,
                "faq_toggle",
                loggedInUserDetails,
                question,
                orderRef,
                locale
              )}
            />
          </Text>
        </Flex>
        <Flex alignItems="center" minWidth="24px">
          <Flex className="see-more-icon" fontSize="1rem">
            {seeMore ? (
              <Minus
                color={iconColor}
                gtmdata={{
                  containerName: data_testid,
                  altContainerName: "faq_toggle",
                  loggedInUserDetails: loggedInUserDetails,
                  altbuttonText: question,
                  orderRef: orderRef,
                  locale: locale
                }}
              />
            ) : (
              <Plus
                color={iconColor}
                gtmdata={{
                  containerName: data_testid,
                  altContainerName: "faq_toggle",
                  loggedInUserDetails: loggedInUserDetails,
                  altbuttonText: question,
                  orderRef: orderRef,
                  locale: locale
                }}
              />
            )}
          </Flex>
        </Flex>
      </Flex>
      {seeMore && (
        <Flex flexDirection="column" justifyContent="center">
          {
            type === FAQ_TYPE.VIDEO ? (
              <Video 
                answer={answer} 
                messageData={messageData}
                metaInfo={metaInfo}
              />
            ) : (
              <Box padding={"1rem 1.5rem"}>
                <Text lineHeight={1.5}>
                  <FormattedMessage html id={answer} values={messageData} />
                </Text>
              </Box>
            ) 
          }
        </Flex>
      )}
    </Flex>
  ) : null;
};

export default FAQItem;
